"use client";

import { useState, type FormEvent } from "react";
import { signIn } from "next-auth/react";

export function SignInForm({
  callbackUrl,
  hasError,
}: {
  callbackUrl: string;
  hasError: boolean;
}) {
  const [token, setToken] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(hasError);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(false);

    const result = await signIn("credentials", {
      token,
      redirect: false,
    });

    if (result?.error) {
      setError(true);
      setSubmitting(false);
      return;
    }

    window.location.href = callbackUrl;
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: 320,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        padding: 32,
        borderRadius: 12,
        background: "#16161d",
      }}
    >
      <h1 style={{ fontSize: 18, margin: 0 }}>Orion Capital</h1>
      <input
        type="text"
        placeholder="Access token"
        value={token}
        onChange={(e) => setToken(e.target.value)}
        autoFocus
        style={{
          padding: "10px 12px",
          borderRadius: 8,
          border: "1px solid #333",
          background: "#0b0b0f",
          color: "#fff",
        }}
      />
      {error && (
        <p style={{ color: "#f87171", fontSize: 13, margin: 0 }}>
          Invalid or expired token.
        </p>
      )}
      <button
        type="submit"
        disabled={submitting || !token}
        style={{
          padding: "10px 12px",
          borderRadius: 8,
          border: "none",
          background: "#4f46e5",
          color: "#fff",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        {submitting ? "Verificando..." : "Entrar"}
      </button>
    </form>
  );
}
